import { isInteger } from '@/helpers/utils'
import { ZERO_DECIMAL_CURRENCIES } from '@/helpers/constants'

/**
 * Форматирует цену с локализацией валюты
 * @param {number} value - Цена
 * @param {string} currency - Валюта
 * @param {string} notation - Формат отображения ('standard', 'compact')
 * @param {number|null} minimumFractionDigits - Минимальное количество знаков после запятой
 * @returns {string} - Форматированная цена
 */
export function formatPrice(value, currency, notation = 'standard', minimumFractionDigits = null, html = false) {
	const locale = window.language
	const formatOptions = {
		currency: currency.toUpperCase(),
		notation,
		style: 'currency',
		currencyDisplay: 'symbol',
	}

	if (ZERO_DECIMAL_CURRENCIES.includes(currency.toUpperCase())) {
		formatOptions.maximumFractionDigits = 0
	} else if (minimumFractionDigits !== null) {
		formatOptions.minimumFractionDigits = minimumFractionDigits
	} else if (isInteger(value)) {
		formatOptions.maximumFractionDigits = 0
	}

	if (['sek', 'nok', 'dkk', 'mxn'].includes(currency)) {
		formatOptions.currencyDisplay = 'name'
	}

	const formatter = new Intl.NumberFormat(locale, formatOptions)
	const parts = formatter.formatToParts(value)

	return parts
		.map((part) => {
			if (html && part.type === 'fraction') {
				part.value = `<span class="price-format__${part.type}">${part.value}</span>`
			}

			if (part.type === 'currency') {
				return '$'
			}
			return part.value
		})
		.join('')
}
